import { render, staticRenderFns } from "./BankDetail.vue?vue&type=template&id=90dd6a24&"
import script from "./BankDetail.vue?vue&type=script&lang=js&"
export * from "./BankDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports